import { GrowthBook, useGrowthBook } from '@growthbook/growthbook-react';
import { useEffect, useState } from 'react';

const useFeatureFlags = () => {
  const growthbook = useGrowthBook();
  const [isFeatureFlagsReady, setIsFeatureFlagsReady] = useState(false);

  useEffect(() => {
    if (growthbook?.ready) {
      setIsFeatureFlagsReady(true);
    }
  }, [growthbook?.ready]);

  const getFeatureValue = (featureKey, attributes = {}) => {
    const currentFeatures = growthbook.getFeatures();
    const currentAttributes = growthbook.getAttributes() || {};

    const localGrowthbook = new GrowthBook();
    localGrowthbook.setFeatures(currentFeatures);
    localGrowthbook.setAttributes({ ...currentAttributes, ...attributes });

    const featureValue = localGrowthbook.getFeatureValue(featureKey);
    localGrowthbook.destroy();

    return featureValue;
  };

  return { getFeatureValue, isFeatureFlagsReady };
};

export default useFeatureFlags;
